export default __webpack_public_path__ + "static/media/001-balloon-yellow.d1f30791.svg";